import {
  BaseDialog,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
interface ProposalSummaryModalProps {
  open: boolean;
  onClose: () => void;
  summary: string;
}

const ProposalSummaryModal: React.FC<ProposalSummaryModalProps> = ({
  open,
  onClose,
  summary,
}) => (
  <BaseDialog open={open} onClose={onClose} title="Proposal Summary">
    <SanitizedTrimmedHtml html={summary} />
  </BaseDialog>
);

export default ProposalSummaryModal;
